import { wishes } from './wishes'
export { wishes }



// WEBPACK FOOTER //
// ./src/models/index.ts